/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { getUsersByRoles } from "../../../apis/SettingApis";
import { Toast } from "primereact/toast";
import { Spin } from "antd";
import { Button } from "primereact/button";
import {
  assignToContractor,
  reAssignToContractor,
} from "../../../apis/ProjectApis";
import { confirmPopup } from "primereact/confirmpopup";
import { ListBox } from "primereact/listbox";
import { Tag } from "primereact/tag";
import { USER_TYPE_CONTRACTOR } from "../../../utils/constants";
import "./style.scss"

const AssignToContractorDialog = (props) => {
  const [apiLoading, setApiLoading] = useState(false);
  const [allEligibleUsers, setAllEligibleUsers] = useState([]);
  const toast = useRef(null);

  const fetchUsers = () => {
    setApiLoading(true);
    getUsersByRoles(USER_TYPE_CONTRACTOR, props.project?.id)
      .then((res) => {
        if (res.status === 200) {
          res.data.unshift({
            id: "",
            numProjectCanAssign: "Assignable Today"
          });
          setAllEligibleUsers(res.data);
          setApiLoading(false);
          console.log(JSON.stringify(res.data));
        } else {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: res.response.data,
            life: 3000,
          });
          setApiLoading(false);
        }
      })
      .catch((e) => {
        toast.current.show({
          severity: "error",
          summary: "Status",
          detail: e,
          life: 3000,
        });
        setApiLoading(false);
      });
  };

  useEffect(() => {
    if (props.visible) {
      fetchUsers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible]);

  const assignProject = (record) => {
    setApiLoading(true);
    let newValues = {
      projectId: props.project.id,
      userId: record.id
    };
    assignToContractor(newValues)
      .then((res) => {
        if (res.status === 200) {
          toast.current.show({
            severity: "success",
            summary: "Status",
            detail: `Project Assign To ${record.name} Successfully`,
            life: 3000,
          });
          setApiLoading(false);
          props.setVisible(false);
        } else {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: res.response.data,
            life: 3000,
          });
          setApiLoading(false);
        }
      })
      .catch((e) => {
        toast.current.show({
          severity: "error",
          summary: "Status",
          detail: e,
          life: 3000,
        });
        setApiLoading(false);
      });
  };

  const reAssignProject = (record) => {
    setApiLoading(true);
    let newValues = {
      projectId: props.project.id,
      userId: record.id,
    };
    reAssignToContractor(newValues)
      .then((res) => {
        if (res.status === 200) {
          toast.current.show({
            severity: "success",
            summary: "Status",
            detail: `Project Assign To ${record.name} Successfully`,
            life: 3000,
          });
          setApiLoading(false);
          props.setVisible(false);
        } else {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: res.response.data,
            life: 3000,
          });
          setApiLoading(false);
        }
      })
      .catch((e) => {
        toast.current.show({
          severity: "error",
          summary: "Status",
          detail: e,
          life: 3000,
        });
        setApiLoading(false);
      });
  };

  return (
    <React.Fragment>
      <div>
        <Toast ref={toast} />
        <Dialog
          header="Assign Contractor"
          visible={props.visible}
          onHide={() => props.setVisible(false)}
        >
          <Spin spinning={apiLoading}>
            <ListBox
              options={allEligibleUsers}
              listClassName="overflow-y-auto"  // Add horizontal scroll
              listStyle={{ height: "50vh", whiteSpace: "nowrap", overflowX: "auto", width: "100%", display: "flex"  }}  // Prevent text wrapping              listStyle={{ height: "50vh" }}
              filter
              optionLabel={(e) => `${e.name} ${e.username}`}
              itemTemplate={(user) => {
                return (
                  <React.Fragment>
                    <div className="flex  align-items-center">
                      <div style={{ width: "8rem" }}>
                        <h5 className="m-0 w-10rem">{user.name}</h5>
                      </div>
                      <div style={{ width: "3rem" }}>
                        <h5 className="m-0 w-10rem" style={{color: "red"}}>{user.level}</h5>
                      </div>
                      <div style={{ width: "12rem", textAlign: "center" }}>
                        <h5 className="m-0 w-10rem">{user.numProjectCanAssign}</h5>
                      </div>
                      <div style={{ width: "12rem"}}>
                        {user.id != "" ? (user.projectHouseTypes ? (
                          <Tag
                            className="bg-gray-400"
                            severity="success"
                            value={
                              <h5 clafssName="m-0 text-black-alpha-90">
                                {user.projectHouseTypes}
                              </h5>
                            }
                          />
                        ) : (""
                        )) : (
                          <h5 className="m-0 w-10rem">Still In Progress</h5>)}
                      </div>
                      {/* <div style={{ width: "12rem" }}>
                        {user.id != "" ? (<Tag
                          className="bg-gray-400"
                          severity="success"
                          value={
                            <h5 className="m-0 text-black-alpha-90">
                              {user.userType}
                            </h5>
                          }
                        />) :
                          (<h5 className="m-0 text-black-alpha-90">
                            User Type
                          </h5>)}
                      </div> */}
                      <div style={{ width: "8rem" }}>
                        {user.id != "" ? (<Button
                          style={{ backgroundColor: "#037eea", zIndex: 9999 }}
                          label="Assign"
                          disabled={
                            props.project?.employee?.id === user.id ||
                            props.project?.qualityChecker?.id === user.id
                          }
                          onClick={(e) => {
                            e.stopPropagation();
                            confirmPopup({
                              target: e.currentTarget,
                              message: "Are you sure you want to proceed?",
                              icon: "pi pi-exclamation-triangle",
                              accept: () =>
                                props?.project?.employee?.id
                                  ? reAssignProject(user)
                                  : assignProject(user),
                            });
                          }}
                        />) : ("")}
                      </div>
                    </div>
                  </React.Fragment>
                );
              }}
            />
          </Spin>
        </Dialog>
      </div>
    </React.Fragment>
  );
};

export default AssignToContractorDialog;
